module.exports = __webpack_public_path__ + "img/ico_menual01_off.7dec31d4.svg";